import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface SpinnerProps {
  dark?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    dark: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(['loading-icon', __props.dark ? 'dark' : ''])
  }, null, 2))
}
}

})